import React from 'react';
// We will use the same 'pulse' animation classes from ProductPage.css/Collections.css

// Helper function to render a single skeleton filter group
const FilterGroupSkeleton = ({ titleLines = 1, optionLines = 4 }) => (
    <div className="filter-group-skeleton skeleton-box" style={{height: 'auto', padding: '15px 10px', marginBottom: '20px'}}>
        {/* Title */}
        {Array(titleLines).fill(0).map((_, i) => (
            <div key={`t-${i}`} className="skeleton-line short-width" style={{height: '18px', marginBottom: '10px'}}></div>
        ))}
        {/* Options */}
        {Array(optionLines).fill(0).map((_, i) => (
            <div key={`o-${i}`} className="skeleton-line medium-width" style={{height: '14px', marginBottom: '8px'}}></div>
        ))}
    </div>
);

// Helper function to render a single product card skeleton
const ProductCardSkeleton = () => (
    <div className="product-card-skeleton">
        {/* Image Placeholder */}
        <div className="product-image-placeholder skeleton-box" style={{height: '350px', marginBottom: '10px'}}></div>

        {/* Title Lines */}
        <div className="skeleton-line medium-width" style={{height: '16px'}}></div>
        <div className="skeleton-line short-width" style={{height: '14px', marginTop: '5px'}}></div>

        {/* Price Line */}
        <div className="skeleton-line extra-short-width" style={{height: '18px', marginTop: '10px'}}></div>
    </div>
);


const CollectionsSkeleton = ({ showFilters }) => {
    // Determine the number of product cards to show (e.g., 8 to fill a common grid layout)
    const cardCount = 8; 

    return (
        <div className="collections-page">
            {/* Header Skeleton */}
            <div className="collections-header">
                {/* Collection Title */}
                <div className="skeleton-line medium-width" style={{height: '32px', width: '250px'}}></div>
                {/* Filter Toggle Button */}
                <div className="hide-filter-btn skeleton-box" style={{width: '120px', height: '40px'}}></div>
            </div>

            <div className="collections-content">
                {/* Filter Sidebar Skeleton (Conditionally rendered like the real sidebar) */}
                {showFilters && (
                    <div className="filter-sidebar-skeleton">
                        <FilterGroupSkeleton />
                        <FilterGroupSkeleton optionLines={3} />
                        <FilterGroupSkeleton optionLines={5} />
                    </div>
                )}

                {/* Main Product Grid Skeleton */}
                <main className="product-grid skeleton-grid">
                    {Array(cardCount).fill(0).map((_, index) => (
                        <ProductCardSkeleton key={index} />
                    ))}
                </main>
            </div>
        </div>
    );
};

export default CollectionsSkeleton;